import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { RoastBatchDetailPageTab } from 'fabscale-app/components/page/roast-batches/details';

export default class RoastBatchesShowIndexController extends Controller {
  queryParams = ['details'];

  @tracked details?: RoastBatchDetailPageTab;
}
